import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const AIIconWrapper = styled.div`
    display: inline;
    div {
        display: inline-flex;
        background: ${palette.indigo[6]};
        padding: 2px;
        border-radius: 2px;
        vertical-align: middle;
        margin: 0 3px;
    }
`;

export const Title = styled.div`
    margin: 24px 0 16px;
`;
